import './App.css';
import Home from './Pages/Home';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Members from './Pages/Members';
import Resources from './Pages/Resources';
import WhyUs from './Pages/WhyUs';
import PagesNotFound from './Pages/PagesNotFound';

function App() {
  return (
    
    <div className="App">
      
      <video src='https://cdn.videvo.net/videvo_files/video/free/2016-12/large_watermarked/Code_flythough_loop_01_Videvo_preview.mp4' autoPlay loop muted></video>
      <Router>
        <Navbar />
        <Routes>
        <Route exact path='/' element={< Home />}></Route>
        <Route exact path='/' element={< Home />}></Route>
        <Route exact path='/members' element={< Members />}></Route>
        <Route exact path='/resources' element={< Resources />}></Route>
        <Route exact path='/why' element={< WhyUs />}></Route>
        <Route path='*' element={<PagesNotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
